/*
  Logout dialog when access token expire
*/

import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'

import Button from '@/shared/Button'

import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const mapStateToProps = ({ auth }) => ({ open: auth.forbidden })

const LogoutModal = ({ dispatch, open }) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const onClose = () => {
    dispatch({ type: 'auth/closeForbiddenModal' })
    navigate(-1)
  }

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>{t('errors.forbidden_access')}</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2">{t('errors.forbidden_account')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="neutral" onClick={() => onClose()}>
          {t('general.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default connect(mapStateToProps)(LogoutModal)
